import React from 'react';
import { alpha, Box, Typography } from '@mui/material';
import { GREENING_BRAND } from './greeningFabActions';
import { GREENING_OAAS_CTA } from './constants';
import { GreeningBrandText } from './GreeningBrandText';

interface Props {
  compact?: boolean;
}

/** CTA OaaS — exibido condicionalmente no rodapé de respostas solucionadoras. */
export function GreeningOaasCta({ compact }: Props) {
  return (
    <Box
      sx={{
        mt: compact ? 0.75 : 1,
        p: compact ? 1.25 : 1.5,
        borderRadius: 1.5,
        bgcolor: alpha(GREENING_BRAND.green, 0.06),
        border: `1px solid ${alpha(GREENING_BRAND.teal, 0.22)}`,
      }}
    >
      <Typography variant="caption" color="text.secondary" component="div" sx={{ lineHeight: 1.55 }}>
        <GreeningBrandText
          text={GREENING_OAAS_CTA}
          variant="caption"
          component="span"
          sx={{ color: 'inherit' }}
        />
      </Typography>
      <Typography
        variant="caption"
        component="div"
        sx={{ display: 'block', mt: 0.5, fontSize: '0.68rem' }}
      >
        <GreeningBrandText
          text="Equipe de Operação OaaS GreenPlat"
          variant="caption"
          component="span"
        />
      </Typography>
    </Box>
  );
}

export default GreeningOaasCta;
